function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 0h16v16H0z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.128 7.35L8.646.868A.916.916 0 007.43.798l-.08.07L.868 7.35a.917.917 0 00-.071 1.217l.071.08 6.482 6.481a.917.917 0 001.217.071l.079-.07 6.482-6.483a.916.916 0 00.07-1.216l-.07-.08z"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 6,
  cy: 6,
  r: 3.25,
  fill: "#FFFEBF"
});

function SvgFeedbackAnswerUpdatedKeyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16
  }, props), _ref, _ref2, _ref3);
}

export default SvgFeedbackAnswerUpdatedKeyIcon;